import "./privacyandterms.scss";
import React, { useEffect } from "react";

function Privacy() {
  useEffect(() => {
    document.body.style.backgroundColor = 'white';
    const script = document.createElement("script");

    script.id = "termly-jssdk";
    script.src = "https://app.termly.io/embed-policy.min.js";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div style={{ backgroundColor: "#fff" }}>
      <div name="termly-embed" data-id="0f9417ae-c9f2-48ee-b786-f31de447f2c4" data-type="iframe"></div>
    </div>
  );
}

export default Privacy;
